// extracted by mini-css-extract-plugin
export var copyable = "_t-1";
export var explainable = "_t-0";
export var negative = "_t-2";
export var positive = "_t-3";